import React from 'react';

export default function SocialMediaSection() {
  return (
    <section id="social-media" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #100c1c 0%, #0d0a14 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* BG mesh */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(168,85,247,0.06) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,107,157,0.06) 0%, transparent 50%)',
        pointerEvents: 'none',
      }} />

      <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
        <div className="section-badge" style={{ margin: '0 auto 20px', display: 'inline-flex' }}>
          <span>📱</span> Chapter 2
        </div>
        <h2 style={{
          fontFamily: 'Poppins, sans-serif', fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 56px)', lineHeight: 1.15, marginBottom: 8,
        }}>
          Introduction on <span className="gradient-text">Social Media</span>
        </h2>
        <div className="section-divider center" />
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          padding: '8px 18px',
          background: 'rgba(168,85,247,0.08)',
          border: '1px solid rgba(168,85,247,0.2)',
          borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
          color: '#d8b4fe', marginBottom: 40,
        }}>
          📅 17 June 2025
        </div>
        <p style={{
          fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
          color: '#9b7ba8', maxWidth: 580, margin: '0 auto 60px',
        }}>
          After their first conversation, Hassan and Fiza connected on social media — officially making their bond digital and opening new doors for their growing friendship. 🌟
        </p>

        {/* Platform cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 24,
        }}>
          {/* Snapchat */}
          <div style={{
            background: 'linear-gradient(135deg, #1a1228 0%, #1e1535 100%)',
            border: '1px solid rgba(255,235,0,0.15)',
            borderRadius: 24, padding: 32,
            position: 'relative', overflow: 'hidden',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            cursor: 'pointer',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            e.currentTarget.style.boxShadow = '0 20px 60px rgba(255,235,0,0.15)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            <div style={{
              position: 'absolute', top: 0, right: 0,
              width: 150, height: 150,
              background: 'radial-gradient(circle, rgba(255,235,0,0.06) 0%, transparent 70%)',
            }} />
            {/* Snap logo SVG */}
            <div style={{
              width: 72, height: 72, borderRadius: 20, margin: '0 auto 24px',
              background: 'linear-gradient(135deg, #FFFC00, #FFD700)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 8px 30px rgba(255,235,0,0.35)',
              animation: 'pulse-glow 3s ease-in-out infinite',
            }}>
              <svg viewBox="0 0 40 40" style={{ width: 40, height: 40 }}>
                <path d="M20,4 C12,4 6,10 6,19 C6,23 7.5,27 10,30 L8,36 L14,34 C16,35 18,35.5 20,35.5 C28,35.5 34,29.5 34,21 C34,12.5 28,4 20,4 Z" fill="white" />
              </svg>
            </div>
            <h3 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 22,
              color: '#fff9fb', marginBottom: 12,
            }}>Snapchat</h3>
            <div style={{
              display: 'inline-block', padding: '4px 16px',
              background: 'rgba(255,235,0,0.1)', borderRadius: 50,
              fontFamily: 'Nunito, sans-serif', fontSize: 12, color: '#FFD700',
              marginBottom: 16,
            }}>
              👻 Connected!
            </div>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 14, lineHeight: 1.7,
              color: '#9b7ba8',
            }}>
              Hassan added Fiza on Snapchat first — streaks started, snaps flew, and their first digital chapter began with yellow hearts and silly filters. 🤳✨
            </p>
            <div style={{
              display: 'flex', gap: 12, marginTop: 24, flexWrap: 'wrap',
            }}>
              {['First Streak 🔥', 'Silly Snaps 😂', 'Good Morning 🌅'].map(t => (
                <span key={t} style={{
                  padding: '6px 14px', background: 'rgba(255,235,0,0.08)',
                  border: '1px solid rgba(255,235,0,0.15)', borderRadius: 50,
                  fontFamily: 'Nunito, sans-serif', fontSize: 12, color: '#FFD700',
                }}>{t}</span>
              ))}
            </div>
          </div>

          {/* Instagram */}
          <div style={{
            background: 'linear-gradient(135deg, #1a1228 0%, #1e1535 100%)',
            border: '1px solid rgba(255,107,157,0.15)',
            borderRadius: 24, padding: 32,
            position: 'relative', overflow: 'hidden',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            cursor: 'pointer',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            e.currentTarget.style.boxShadow = '0 20px 60px rgba(255,107,157,0.15)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            <div style={{
              position: 'absolute', top: 0, right: 0,
              width: 150, height: 150,
              background: 'radial-gradient(circle, rgba(255,107,157,0.06) 0%, transparent 70%)',
            }} />
            <div style={{
              width: 72, height: 72, borderRadius: 20, margin: '0 auto 24px',
              background: 'linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 8px 30px rgba(255,107,157,0.35)',
              animation: 'pulse-glow 3s ease-in-out infinite 0.5s',
            }}>
              <svg viewBox="0 0 40 40" style={{ width: 36, height: 36 }}>
                <rect x="6" y="6" width="28" height="28" rx="8" fill="none" stroke="white" strokeWidth="2.5" />
                <circle cx="20" cy="20" r="8" fill="none" stroke="white" strokeWidth="2.5" />
                <circle cx="29" cy="11" r="2" fill="white" />
              </svg>
            </div>
            <h3 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 22,
              color: '#fff9fb', marginBottom: 12,
            }}>Instagram</h3>
            <div style={{
              display: 'inline-block', padding: '4px 16px',
              background: 'rgba(255,107,157,0.1)', borderRadius: 50,
              fontFamily: 'Nunito, sans-serif', fontSize: 12, color: '#ff6b9d',
              marginBottom: 16,
            }}>
              💌 Following!
            </div>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 14, lineHeight: 1.7,
              color: '#9b7ba8',
            }}>
              Instagram was where they discovered each other's worlds — reels, stories, DMs, and double-taps. Their virtual bond grew stronger with every notification. 📸💕
            </p>
            <div style={{
              display: 'flex', gap: 12, marginTop: 24, flexWrap: 'wrap',
            }}>
              {['DMs 💌', 'Story Replies 👀', 'Heart Reacts ❤️'].map(t => (
                <span key={t} style={{
                  padding: '6px 14px', background: 'rgba(255,107,157,0.08)',
                  border: '1px solid rgba(255,107,157,0.15)', borderRadius: 50,
                  fontFamily: 'Nunito, sans-serif', fontSize: 12, color: '#ff6b9d',
                }}>{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}